import { createStore } from 'vuex'
import inspection from './inspection'
import inspection_call from './inspection_call'
import inspection_image from './inspection_image'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('inspection_image/clearAll', null, { root: true })
      dispatch('inspection/clearAll', null, { root: true })
      dispatch('inspection_call/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('inspection_image/clearAll', null, { root: true })
      dispatch('inspection/clearAll', null, { root: true })
      dispatch('inspection_call/clearAll', null, { root: true })
    },
  },
  modules: {
    inspection_image,
    inspection,
    inspection_call,
  },
})

export default store
